// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyAhgIWGLDgxcbKu24UrAao6L8ELA_tF888",
    authDomain: "percent-map.firebaseapp.com",
    projectId: "percent-map",
    storageBucket: "percent-map.appspot.com",
    messagingSenderId: "682491031527",
    appId: "1:682491031527:web:d50fc7affc0ca9100f9742",
    measurementId: "G-HEGTVGVFH4"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
const auth = getAuth(app);

export { auth };